var _circle, _circle2, _path, _rect, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "url(#paint0_linear_1670_311)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 12,
    r: 10.5,
    fill: "#4D44C9",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96 9.344C6.03467 8.36267 6.41333 7.59467 7.096 7.04C7.77867 6.48533 8.664 6.208 9.752 6.208C10.4773 6.208 11.1013 6.34133 11.624 6.608C12.1573 6.864 12.5573 7.216 12.824 7.664C13.1013 8.112 13.24 8.61867 13.24 9.184C13.24 9.84533 13.048 10.416 12.664 10.896C12.2907 11.376 11.8 11.6853 11.192 11.824V11.904C11.8853 12.0747 12.4347 12.4107 12.84 12.912C13.2453 13.4133 13.448 14.0693 13.448 14.88C13.448 15.488 13.3093 16.0373 13.032 16.528C12.7547 17.008 12.3387 17.3867 11.784 17.664C11.2293 17.9413 10.5627 18.08 9.784 18.08C8.65333 18.08 7.72533 17.7867 7 17.2C6.27467 16.6027 5.86933 15.76 5.784 14.672H7.192C7.26667 15.312 7.528 15.8347 7.976 16.24C8.424 16.6453 9.02133 16.848 9.768 16.848C10.5147 16.848 11.08 16.656 11.464 16.272C11.8587 15.8773 12.056 15.3707 12.056 14.752C12.056 13.952 11.7893 13.376 11.256 13.024C10.7227 12.672 9.91733 12.496 8.84 12.496H8.472V11.28H8.856C9.83733 11.2693 10.5787 11.1093 11.08 10.8C11.5813 10.48 11.832 9.98933 11.832 9.328C11.832 8.76267 11.6453 8.30933 11.272 7.968C10.9093 7.62667 10.3867 7.456 9.704 7.456C9.04267 7.456 8.50933 7.62667 8.104 7.968C7.69867 8.30933 7.45867 8.768 7.384 9.344H5.96Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 26,
    height: 19.6585,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0449,
    y: 46.0976,
    width: 17.9111,
    height: 1.90244,
    rx: 0.951219,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2441,
    y: 43.561,
    width: 8.08889,
    height: 3.17073,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1670_311",
    x1: 35,
    y1: 0,
    x2: 35,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5744C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B43DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDesktop);
export default __webpack_public_path__ + "static/media/activeDesktop.681095abed9ceb857e1e62104786a8fe.svg";
export { ForwardRef as ReactComponent };